import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { c } from '@debbie/cortex/dist/index.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
const BankTransfer = (props) => {
    const { paymentOption, collector, case: singleCase } = props;
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const me = useSelector(selectMe);
    const lang = useSelector((s) => s.lang);
    useEffect(() => {
        if (singleCase) {
            c.customers.getById(singleCase.customerId);
        }
    }, [singleCase]);
    const user = customer && me && customer.users.find((user) => user.userId === me.id);
    return (React.createElement("div", null,
        React.createElement("h2", null, lang.debtorWebHome.payWithBankTransfer),
        React.createElement("p", null, lang.debtorWebHome.payWithBankTransferText),
        React.createElement(Account, null,
            React.createElement("li", null, 
            // @ts-ignore
            paymentOption.details?.bankName),
            React.createElement("li", null,
                lang.debtorWebHome.registrationNumber,
                ' ',
                React.createElement("b", null, 
                // @ts-ignore
                paymentOption.details?.registrationNumber)),
            React.createElement("li", null,
                lang.debtorWebHome.accountNumber,
                ' ',
                React.createElement("b", null, 
                // @ts-ignore
                paymentOption.details?.accountNumber)),
            React.createElement(BoldText, null,
                "*",
                lang.debtorWebHome.payWithBankTransferInfo,
                ": ",
                singleCase.id,
                "-",
                user && user.id))));
};
export default BankTransfer;
export const Account = styled.ul `
  padding-left: 0;

  li {
    list-style: none;
  }
`;
export const BoldText = styled.p `
  color: black;
  font-size: 0.8em;
  font-weight: bold;
  margin-top: 6px;
`;
//# sourceMappingURL=BankTransfer.js.map